import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import "./ChatBot.css";
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Feature, Chat, Tool, Jurisdiction } from '../../Features/ChatBot/index';
import send from "../../assets/images/chatbot/send.svg"
import miniStar from "../../assets/images/chatbot/ministar.svg"
import power from "../../assets/images/chatbot/power.svg"
import axios from "axios"
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { message } from 'antd';
import userImg from "../../assets/images/chatbot/user-chat.svg"
import botImg from "../../assets/images/chatbot/chat-chatbot.svg"
import copyIcon from "../../assets/images/chatbot/copy.svg"
import ReactMarkdown from 'react-markdown';
import Skeleton from 'react-loading-skeleton';
import { SpinnerLoading } from "../../Components"
import Tooltip from '@mui/material/Tooltip';
import Modal from "react-modal";
import refrence from "../../assets/images/svg/refrence.svg"
import likeIcon from "../../assets/images/svg/like.svg"
import disLikeIcon from "../../assets/images/svg/dislike.svg"
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Alternatively, add inline SVG
import userItem from "../../assets/images/chatbot/user-item.svg"
import JusModal from '@mui/material/Modal';
import AiModal from '@mui/material/Modal';

import { Worker } from '@react-pdf-viewer/core'
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { TextareaAutosize } from '@mui/material';
import TextArea from 'antd/es/input/TextArea';
import { FormControl, InputLabel, Select, MenuItem, Typography, Box } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { bg } from 'date-fns/locale';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;




const StarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.2206 15.2118L12.2189 15.2147C11.9317 15.6723 11.6964 16.1214 11.5152 16.5618C10.9694 15.229 9.93046 13.8205 8.3623 12.6441C7.70933 12.1516 7.03757 11.7589 6.35552 11.4783C8.01601 10.8088 9.55307 9.60074 10.6106 8.06691C10.9825 7.52959 11.2853 6.9878 11.5128 6.43246C12.1337 7.95297 13.3483 9.4305 14.8407 10.4867C15.4219 10.9001 16.024 11.2367 16.6432 11.4878C14.9048 12.2234 13.1775 13.7018 12.2206 15.2118Z" stroke="#686868" stroke-width="1.5" />
        <path d="M4.80682 6.44722L4.80682 6.44722L4.80563 6.4491C4.69179 6.63054 4.59247 6.81014 4.50835 6.9878C4.18992 6.31467 3.6472 5.62355 2.86827 5.03922C2.57595 4.81875 2.27581 4.63411 1.97037 4.48956C2.8029 4.10916 3.56382 3.484 4.10019 2.70606C4.25883 2.47687 4.39499 2.24545 4.50676 2.00949C4.86867 2.77499 5.49325 3.50201 6.24322 4.03278C6.4987 4.21452 6.76218 4.36956 7.03252 4.4952C6.14656 4.92226 5.29499 5.67683 4.80682 6.44722Z" stroke="#686868" />
    </svg>
);
const handleModelChange = (e) => {
    const selectedModel = e.target.value;
    // Update your state or make API calls based on selected model

};

const AnswersIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1515_1110)">
            <path d="M9.99976 7.50004C8.15809 7.50004 7.49976 8.15837 7.49976 10C7.49976 11.8417 8.15801 12.5 9.99968 12.5C11.8413 12.5 12.4998 11.8417 12.4998 10C12.4998 8.15837 11.8414 7.50004 9.99976 7.50004ZM17.4497 9.16671C17.0663 5.69171 14.308 2.93337 10.833 2.55004V0.833374H9.16634V2.55004C5.69134 2.93337 2.93301 5.69171 2.54967 9.16671H0.833008V10.8334H2.54967C2.93301 14.3084 5.69134 17.0667 9.16634 17.45V19.1667H10.833V17.45C14.308 17.0667 17.0663 14.3084 17.4497 10.8334H19.1663V9.16671H17.4497ZM9.99968 15.8334C6.77468 15.8334 4.16634 13.225 4.16634 10C4.16634 6.77504 6.77468 4.16671 9.99968 4.16671C13.2247 4.16671 15.833 6.77504 15.833 10C15.833 13.225 13.2247 15.8334 9.99968 15.8334Z" fill="#686868" />
        </g>
        <defs>
            <clipPath id="clip0_1515_1110">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const EfficiencyIcon = () => (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.3337 0L14.242 1.90833L10.1753 5.975L6.84199 2.64167L0.666992 8.825L1.84199 10L6.84199 5L10.1753 8.33333L15.4253 3.09167L17.3337 5V0H12.3337Z" fill="#686868" />
    </svg>
)

const ClearIcon = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="delete" clip-path="url(#clip0_1515_1064)">
            <path id="Vector" d="M13.3332 7.5V15.8333H6.6665V7.5H13.3332ZM12.0832 2.5H7.9165L7.08317 3.33333H4.1665V5H15.8332V3.33333H12.9165L12.0832 2.5ZM14.9998 5.83333H4.99984V15.8333C4.99984 16.75 5.74984 17.5 6.6665 17.5H13.3332C14.2498 17.5 14.9998 16.75 14.9998 15.8333V5.83333Z" fill="#474747" />
        </g>
        <defs>
            <clipPath id="clip0_1515_1064">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const StarsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Frame 84">
            <g id="Group 2">
                <path id="&#226;&#156;&#166;" d="M12.2206 15.2118L12.2189 15.2147C11.9317 15.6723 11.6964 16.1214 11.5152 16.5618C10.9694 15.229 9.93046 13.8205 8.3623 12.6441C7.70933 12.1516 7.03757 11.7589 6.35552 11.4783C8.01601 10.8088 9.55307 9.60074 10.6106 8.06691C10.9825 7.52959 11.2853 6.9878 11.5128 6.43246C12.1337 7.95297 13.3483 9.4305 14.8407 10.4867C15.4219 10.9001 16.024 11.2367 16.6432 11.4878C14.9048 12.2234 13.1775 13.7018 12.2206 15.2118Z" stroke="#474747" stroke-width="1.5" />
                <path id="&#226;&#156;&#166;_2" d="M4.80682 6.44722L4.80682 6.44722L4.80563 6.4491C4.69179 6.63054 4.59247 6.81014 4.50835 6.9878C4.18992 6.31467 3.6472 5.62355 2.86827 5.03922C2.57595 4.81875 2.27581 4.63411 1.97037 4.48956C2.8029 4.10916 3.56382 3.484 4.10019 2.70606C4.25883 2.47687 4.39499 2.24545 4.50676 2.00949C4.86867 2.77499 5.49325 3.50201 6.24322 4.03278C6.4987 4.21452 6.76218 4.36956 7.03252 4.4952C6.14656 4.92226 5.29499 5.67683 4.80682 6.44722Z" stroke="#474747" />
            </g>
        </g>
    </svg>
);

const OpenInNewIcon = () => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="open_in_new" clip-path="url(#clip0_1515_1080)">
            <path id="Vector" d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z" fill="#474747" />
        </g>
        <defs>
            <clipPath id="clip0_1515_1080">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);


const countLines = (text) => {
    const lines = text.split(/\r\n|\r|\n/); // Split by line breaks
    return lines.length;
};

const ChatBot = ({ translations }) => {
    const chatbotUrl = "https://chat-d.polarisai.ca"
    const [chatInput, setChatInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [currentStream, setCurrentStream] = useState('');
    const [loading, setLoading] = useState(false);
    const [exitLoading, setExitLoading] = useState(false);
    const [chatLoading, setChatLoading] = useState(false);
    const [activeChat, setActiveChat] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [error, setError] = useState(null);
    const [lineCount, setLineCount] = useState(0);
    const [isLoadingPrevious, setIsLoadingPrevious] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            return savedTheme === 'dark';
        } else {
            // Default to dark mode if no theme is set
            return false;
        }
    });


 
    const [sessionId, setSessionId] = useState('');
    const [page, setPage] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const chatContainerRef = useRef(null);

    const fullName = Cookies.get("full_name");
    const userName = Cookies.get("username");
    const apiKey = Cookies.get("api_key")
    const apiSecret = Cookies.get("api_secret");

    useEffect(() => {
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    }, [isDarkMode]);


    // Jurisdiction Modal
    const [jurisdiction, setJurisdiction] = useState(false);
    const handleOpenJurisdiction = () => setJurisdiction(true);
    const handleCloseJurisdiction = () => setJurisdiction(false);
    // End Jurisdiction Modal



    const CustomMenuProps = {
        PaperProps: {
            sx: {
                bgcolor: isDarkMode ? '#2f2f2f' : '#fff',
            },
        },
        MenuListProps: {
            sx: {
                bgcolor: isDarkMode ? '#2f2f2f' : '#fff',
                border: "unset", // Background color
                '& ul': {
                    padding: '8px', // Add padding to the list
                },
            },
        },
    };
   

    // useEffect(() => {
    //     fetch(`${chatbotUrl}/get_logged_user`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify({
    //             api_key: `${apiKey}`,
    //             api_secret: `${apiSecret}`,
    //         }),
    //     })
    //     .then(async response => {
    //         if (!response.ok) {
    //             // If the response status is 500, extract the error message
    //             if (response.status === 500) {
    //                 const errorData = await response.json();
    //                 throw new Error(errorData.detail || 'An unexpected error occurred');
    //             } else {
    //                 throw new Error('An unexpected error occurred');
    //             }
    //         }
    //         return response.json();
    //     })
    //     .then(data => {
    //         console.log('Success:', data);
    //         // handle successful data here
    //     })
    //     .catch(error => {
    //         let errorMessage = "An unexpected error occurred";
    //         if (error.message) {
    //             errorMessage = error.message; // This will be the detail from the error response
    //         }

    //         setError(errorMessage);
    //         toast.error(errorMessage, {
    //             position: "top-right",
    //             autoClose: false,
    //             hideProgressBar: true,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //             theme: "colored",
    //             className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
    //         });
    //     });
    // }, [chatbotUrl, apiSecret, isDarkMode]);


    const [currentModel, setCurrentModel] = useState("polaris")
    const [showWarn, setShowWarn] = useState(false);

    const closeWarn = () => {
      setShowWarn(false);
  };
    const handleModelChange = (event) => {

      console.log(event.target.value)
        setCurrentModel(event.target.value);
        if(event.target.value === "openai"){
          setShowWarn(true);
        }
    };


    useEffect(() => {
      if (currentModel === "openai") {
        const interval = setInterval(() => {
          setShowWarn(true);
        }, 1 * 60 * 1000); // 5 minutes in milliseconds
  
        return () => clearInterval(interval); // Cleanup on unmount
      }
    }, [currentModel]);


    const toggleTheme = () => {
        setIsDarkMode(prevMode => !prevMode);
    };


    // 1- Send click api 
    const handleSendClick = async () => {
        if (!chatInput.trim() || isSending) return;
    
        setIsSending(true);  // Prevent further calls until response is complete
    
        let currentSessionId = messages.length === 0 ? await createNewChat() : sessionId;
        const url = `${chatbotUrl}/conversation/invoke`;
        const payload = JSON.stringify({
            api_key: apiKey,
            api_secret: apiSecret,
            question: chatInput,
            session_id: currentSessionId,
            model: currentModel,
        });
    
        setMessages(prevMessages => [
            ...prevMessages,
            { text: chatInput, isUser: true },
        ]);
    
        scrollToBottom();
        setLoading(true);
    
        const xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'text';
    
        const references = new Set();  // Use a Set to store unique references
        let message_id = "";
        let conversationTitle = '';
        let accumulatedResponse = '';
    
        xhr.onprogress = function () {
            const chunks = xhr.responseText.split("\n\n");
        
            chunks.forEach((chunk) => {
                if (chunk.startsWith("data: ")) {
                    try {
                        const jsonData = JSON.parse(chunk.replace("data: ", "").trim());
        
                        if (jsonData.content && jsonData.content.trim() !== '') {
                            accumulatedResponse = jsonData.content;
                            setCurrentStream(jsonData.content);
                            scrollToBottom();
                        }
        
                        if (jsonData.title) {
                            conversationTitle = jsonData.title;
                        }
        
                        if (jsonData.reference) {
                            references.add(jsonData.reference); // Add the entire reference object to Set
                        }
        
                        if (jsonData.id) {
                            message_id = jsonData.id;
                        }
                    } catch (error) {
                        console.error('Failed to parse JSON chunk:', error, chunk);
                    }
                }
            });
        
            if (xhr.responseText.length > 0) {
                setLoading(false);
            }
        };
    
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                setLoading(false);
                setIsSending(false);
            
                if (xhr.status === 200 && accumulatedResponse.trim() !== '') {
                    setMessages(prevMessages => [
                        ...prevMessages,
                        {
                            text: accumulatedResponse.trim(),
                            references: Array.from(references), // Convert Set to Array
                            message_id: message_id,
                            isUser: false,
                        },
                    ]);
            
                    setCurrentStream('');
            
                    setConversations(prevConversations =>
                        prevConversations.map(chat =>
                            chat.name === currentSessionId
                                ? { ...chat, conversation_title: conversationTitle }
                                : chat
                        )
                    );
            
                    scrollToBottom();
                } else {
                    console.error('Error:', xhr.statusText);
                }
            }            
        };
    
        xhr.send(payload);
        setChatInput('');
    };
    
    
    





    // 2- Converstions List api 
    const [fullNames, setFullNames] = useState([]);
    const [selectedName, setSelectedName] = useState('');
    const [nameToUserMap, setNameToUserMap] = useState({});
    const [conversations, setConversations] = useState([]);
    
    const [filteredChats, setFilteredChats] = useState([]); // المحادثات المحملة حاليًا
    const [currentPage, setCurrentPage] = useState(1); // الصفحة الحالية
    const [isFetchingMore, setIsFetchingMore] = useState(false); // حالة تحميل المزيد
    const [canFetchMore, setCanFetchMore] = useState(true); // هل يمكن تحميل المزيد










    
    useEffect(() => {
        fetch(`${chatbotUrl}/conversation/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                api_key: `${apiKey}`,
                api_secret: `${apiSecret}`,
            }),
        })
            .then(response => response.json())
            .then(data => {

                setConversations(data);
                const namesMap = {};
                data.forEach(item => {
                    const displayName = item.full_name || item.user; 
                    namesMap[displayName] = item.user; 
                });
    
                const uniqueNames = Array.from(new Set(Object.keys(namesMap)));
                setFullNames(uniqueNames);
                setNameToUserMap(namesMap);
            })
            .catch(error => {
                setError(error.message);
                toast.error(`${error}`, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
                });
            });
    }, [chatbotUrl]);


    const fetchFilteredChats = (user, page = 1) => {
        if (isFetchingMore) return; // منع الطلب إذا كان هناك تحميل جارٍ بالفعل
    
        setIsFetchingMore(true); // إظهار مؤشر التحميل
    
        // إضافة تأخير مدته 5 ثوانٍ قبل جلب البيانات
        setTimeout(() => {
            const body = {
                api_key: apiKey,
                api_secret: apiSecret,
                limit: 20,   
                page,   
                user: user || undefined,       
            };
    
            fetch(`${chatbotUrl}/conversation/list`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.length < 20) {
                        setCanFetchMore(false); // إذا كانت البيانات أقل من الحد، توقف عن التحميل
                    }
                    setFilteredChats((prevChats) => [...prevChats, ...data]); // إضافة البيانات الجديدة إلى المحادثات الحالية
                })
                .catch((error) => {
                    setError(error.message);
                    toast.error(`${error}`, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
                    });
                })
                .finally(() => {
                    setIsFetchingMore(false); // إخفاء مؤشر التحميل
                });
        }, 4000);    
    };
    
    
    
    
    const handleNameChange = (event) => {
        const selected = event.target.value;
        setSelectedName(selected);
    
        const user = nameToUserMap[selected] || undefined;
        setCurrentPage(1); // إعادة الصفحة إلى الأولى
        setCanFetchMore(true); // إعادة تفعيل إمكانية التحميل
        setFilteredChats([]); // إعادة تعيين المحادثات المحملة
        fetchFilteredChats(user, 1); // تحميل المحادثات المفلترة للصفحة الأولى
    };
    
    
    


    // useEffect(() => {
    //     fetchFilteredConversations(); // Fetch all conversations without filtering
    // }, [chatbotUrl]);


    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && canFetchMore && !isFetchingMore) {
                    const nextPage = currentPage + 1;
                    setCurrentPage(nextPage);
                    fetchFilteredChats(selectedName ? nameToUserMap[selectedName] : undefined, nextPage);
                }
            },
            { root: null, rootMargin: "100px", threshold: 1.0 }
        );
    
        if (chatContainerRef.current) {
            observer.observe(chatContainerRef.current);
        }
    
        return () => {
            if (chatContainerRef.current) {
                observer.unobserve(chatContainerRef.current);
            }
        };
    }, [chatContainerRef, canFetchMore, isFetchingMore, currentPage, selectedName]);
    
    
    
    
    
    

    // // filter the converstions by the name
    // const handleNameChange = (event) => {
    //     setSelectedName(event.target.value);
    // };
    
    // Filter conversations based on the `user` of the selected name
    // const filteredConversations = selectedName
    //     ? conversations.filter(item => item.user === nameToUserMap[selectedName])
    //     : conversations;




    // Send the Message onClick Enter
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.shiftKey) {
            // Add a new line when Shift+Enter is pressed
            event.preventDefault(); // Prevent default Enter behavior
            setChatInput((prev) => prev + '\n');
        } else if (event.key === 'Enter') {
            // Call handleSendClick when Enter is pressed without Shift
            event.preventDefault();
            handleSendClick();
        }
    };


    const [textareaHeight, setTextareaHeight] = useState(26); 

    const textareaRef = useRef(null); // Use a ref to directly manipulate the DOM element

    const handleInputChange = (e) => {
        const textarea = textareaRef.current;
    
        // Reset height to 'auto' to calculate the current height
        textarea.style.height = "auto";
    
        // Calculate the new height based on the content or reset to 24px if empty
        const newHeight = e.target.value ? Math.max(26, Math.min(textarea.scrollHeight, 150)) : 26;
        textarea.style.height = `${newHeight}px`;
    
        // Update the height state
        setTextareaHeight(newHeight);
    
        // Update the input value
        setChatInput(e.target.value);
    };


     // if the response is arabic 
     const isArabicText = (text) => {
        const arabicPattern = /[\u0600-\u06FF]/;
        return arabicPattern.test(text);
    };


    // 3- See the Details of Conversation

    const [oldConversation, setOldConversation] = useState([]);
    const handleDetails = (conversation) => {
        setActiveChat(conversation);
        fetch(`${chatbotUrl}/conversation/details`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                api_key: apiKey,
                api_secret: apiSecret,
                session_id: conversation,
                page: 1,
            }),
        })
            .then(response => response.json())
            .then(data => {
                const formattedData = data.map(item => {                    
                    return {
                        text: item.content,
                        isUser: item.type === 'user',
                        references: item.references,
                        message_id: item.id,
                        like: item.like
                    };
                });



                setMessages(formattedData);
                setOldConversation(formattedData);


                const url = new URL(window.location.href);
                url.search = `?${encodeURIComponent(conversation)}`;
                window.history.replaceState(null, '', url);

                setSessionId(conversation);
            })
            .catch(error => {
                setError(error.message);
                toast.error(`${error}`, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
                });
            });
    };

    useEffect(() => {
        const params = window.location.search.substring(1); // Remove the "?" from the search string
        if (params) {
            const sessionId = decodeURIComponent(params);
            handleDetails(sessionId);
        }
    }, []);





    // 4- Create New Chat api
    const createNewChat = async () => {
        try {
            const response = await axios.post(`${chatbotUrl}/conversation/new`, {
                api_key: `${apiKey}`,
                api_secret: `${apiSecret}`,
                top_p: 9,
                top_k: 50,
                temperature: 0.5,
                model: "llama3.1"
            });
            const newSessionId = response?.data?.details?.name;

            // Add the new conversation to the existing list, with the new chat at the beginning
            setConversations(prevConversations => [
                {
                    name: newSessionId,
                    conversation_title: response?.data?.details?.title || "Untitled",
                },
                ...prevConversations,
            ]);

            // Set the new chat as active
            setActiveChat(newSessionId);

            setSessionId(newSessionId);

            // Update the URL with the new session_id
            const url = new URL(window.location.href);
            url.search = `?${encodeURIComponent(newSessionId)}`;
            window.history.replaceState(null, '', url);

            return newSessionId;
        } catch (error) {
            setError(error.message);
            toast.error(`${error}`, {
                position: "top-right",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
            });
        }
    };

    const handleNewChatClick = () => {
        // Clear messages and reset the chat input and stream
        setMessages([]);
        setCurrentStream('');
        setChatInput('');

        // Remove the session_id from the URL
        const url = new URL(window.location.href);
        url.search = ''; // Clear the query string
        window.history.replaceState(null, '', url);

        // Optionally, reset the sessionId in the state if needed
        setSessionId(null);
    };



    // 5- Delete Chat
    const handleDelete = async (conv) => {
        if (activeChat === conv) setActiveChat(null);
        setChatLoading(true); // Set loading to true
        try {
            const response = await fetch(`${chatbotUrl}/conversation/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    api_key: `${apiKey}`,
                    api_secret: `${apiSecret}`,
                    session_id: `${conv}`,
                }),
            });

            if (response.ok) {
                // If the delete was successful, remove the conversation from the state
                setConversations(prevConversations =>
                    prevConversations.filter(item => item.name !== conv)
                );
                handleNewChatClick();
            } else {
                console.error('Failed to delete conversation');
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setChatLoading(false); // Set loading to false once the operation is complete
        }
    };


    const [left, setLeft] = useState('-100%');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [overlay, setOverlay] = useState("none");

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const ShowSidbarClick = () => {

        setLeft('0');
        setOverlay("block");

    };
    const HideSidbarClick = () => {

        setLeft('-100%');
        setOverlay("none");

    };

    // Auto Scroll On New Messages 
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    // Auto scroll after every new message or streamed message with two lines
    useEffect(() => {
        scrollToBottom();
    }, [messages, currentStream]);


    // Copy ChatBot Response
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success('Copied to clipboard!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: isDarkMode ? "dark" : "light",
                className: isDarkMode ? "chatbot-copy-toast" : ""
            });
        }).catch(err => {
            toast.error('Failed to copy!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: isDarkMode ? "dark" : "light",
                className: isDarkMode ? "chatbot-copy-toast" : ""
            });
        });
    };


    // copy the Link of the Chat 
    const handleShareChat = (name) => {
        const url = new URL(window.location.href);
        url.search = ''; // Clear the existing query string
        const chatLink = `${url.origin}${url.pathname}?${name}`; // Construct the new URL with the session ID

        navigator.clipboard.writeText(chatLink)
            .then(() => {
                toast.success('Link copied to clipboard!', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: isDarkMode ? "colored" : "light",
                    className: isDarkMode ? "chatbot-copy-toast" : ""
                });
            })
            .catch(err => {
                toast.error('Failed to copy the link!', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: isDarkMode ? "colored" : "light",
                    className: isDarkMode ? "chatbot-copy-toast" : ""
                });
            });
    };



    const getDirection = (text) => {
        // Check if the text contains any Arabic characters (or other RTL characters)
        const rtlPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
        return rtlPattern.test(text) ? 'rtl' : 'ltr';
    };




    // Loading More Messages (Pagination)
    useEffect(() => {
        // Detect when the user scrolls to the top
        const handleScroll = () => {
            if (chatContainerRef.current) {
                const { scrollTop } = chatContainerRef.current;
                if (scrollTop === 0 && !loadingMore && messages.length > 0) {
                    // User scrolled to the top, load more messages
                    loadMoreMessages();
                }
            }
        };

        const chatContainer = chatContainerRef.current;

        if (chatContainer) {
            // Attach the scroll event listener
            chatContainer.addEventListener('scroll', handleScroll);

            // Check if the user is already at the top of the chat container
            if (chatContainer.scrollTop === 0 && loadingMore && messages.length > 0) {
                // Manually trigger loading more messages if already at the top
                loadMoreMessages();
            }
        }

        return () => {
            if (chatContainer) {
                chatContainer.removeEventListener('scroll', handleScroll);
            }
        };
    }, [loadingMore, messages.length]);

    const loadMoreMessages = () => {
        setLoadingMore(true);
        setIsLoadingPrevious(true); // Set to true when loading previous messages

        const chatContainer = chatContainerRef.current;
        const previousScrollHeight = chatContainer.scrollHeight; // Capture the current scroll height
        const previousScrollTop = chatContainer.scrollTop; // Capture current scroll position

        fetch(`${chatbotUrl}/conversation/details`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                api_key: apiKey,
                api_secret: apiSecret,
                session_id: sessionId,
                page: page + 1, // Increment page number to load older messages
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Ensure that data is an array before attempting to map
                if (!Array.isArray(data)) {
                    console.error('Received data is not an array or is null:', data);
                    setLoadingMore(false);
                    setIsLoadingPrevious(false);
                    return;
                }

                // If data is empty, stop further requests
                if (data.length === 0) {
                    setLoadingMore(false);
                    setIsLoadingPrevious(false);
                    return;
                }

                const formattedData = data.map(item => ({
                    text: item.content,
                    isUser: item.type === 'user',
                }));

                // Prepend the new messages at the top of the list
                setMessages(prevMessages => [...formattedData, ...prevMessages]);
                setOldConversation(prevMessages => [...formattedData, ...prevMessages]);

                setPage(prevPage => prevPage + 1);

                // Adjust the scroll position to maintain the user's current position
                setTimeout(() => {
                    const newScrollHeight = chatContainer.scrollHeight;
                    chatContainer.scrollTop = previousScrollTop + (newScrollHeight - previousScrollHeight);
                    setIsLoadingPrevious(false); // Reset the flag after loading previous messages
                }, 0);

                setLoadingMore(false);
            })
            .catch(error => {
                setLoadingMore(false);
                setIsLoadingPrevious(false); // Ensure the flag is reset even on error
                console.error('Error loading more messages:', error);
            });
    };



    // Pdf Viewer 
    // const [firstResizable, setFirstResizable] = useState(false);
    // const [secondResizable, setSecondResizable] = useState(false);

    // const handleResize = (event, { size }) => {
    //     if (size.width >= 430) {
    //         setFirstResizable(true);
    //     } else {
    //         setFirstResizable(false);
    //     }
    //     if (size.width > 400 && window.innerWidth < 992) {
    //         setSecondResizable(true);
    //         setFirstResizable(false);
    //     }
    //     else {
    //         setSecondResizable(false);
    //     }
    // };

    // const [showPdf, setShowPdf] = useState(false);
    // const toggleViewer = () => {
    //     setShowPdf(false);
    // };


    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);
    // const [inputPageNumber, setInputPageNumber] = useState(1);
    // const [bookmarks, setBookmarks] = useState([]);
    // const [pdfLoaded, setPdfLoaded] = useState(false);
    // const [pendingPage, setPendingPage] = useState(null);
    // const pageRefs = useRef([]);
    // const [pdfDocument, setPdfDocument] = useState(null); // Cache loaded PDF document
    // const [loadingAssets, setLoadingAssets] = useState(true)
    // const [isReadyToLoadPdf, setIsReadyToLoadPdf] = useState(false);
    // const [fullScreenPage, setFullScreenPage] = useState(null);
    // const [focusedPage, setFocusedPage] = useState(null);
    

    // // Memoize the PDF file path to ensure it's only loaded once

    // const pdfFile = useMemo(() => require("../../assets/files/Dubai_Building_Code_English_2021_Edition_compressed.pdf"), []);

    // useEffect(() => {
    //     const loadAssets = async () => {
    //         // Replace with actual loading logic for images, fonts, and API calls
    //         await Promise.all([
    //             new Promise(resolve => setTimeout(resolve, 2000)), // Simulated image loading
    //             fetchSomeData(), // Simulated API call
    //         ]);
    //         setLoadingAssets(false);
    //     };
    //     loadAssets();
    // }, []);

    // const fetchSomeData = async () => {
    //     // Simulate an API call
    //     await new Promise(resolve => setTimeout(resolve, 2000));
    // };

    // useEffect(() => {
    //     // Load PDF only when all assets are ready
    //     if (!loadingAssets) {
    //         setIsReadyToLoadPdf(true);
    //     }
    // }, [loadingAssets]);

    // useEffect(() => {
    //     if (isReadyToLoadPdf) {
    //         // Logic to load PDF here
    //         loadPdf();
    //         setIsReadyToLoadPdf(false); // Reset after loading PDF
    //     }
    // }, [isReadyToLoadPdf]);

    // const loadPdf = () => {
    //     // Placeholder function to load the PDF
    //     // Replace with your actual PDF loading logic if needed
    //     console.log('Loading PDF...');
    // };


    // // When PDF is successfully loaded
    // const onDocumentLoadSuccess = async (pdf) => {
    //     setNumPages(pdf.numPages);
    //     setPageNumber(1);
    //     setPdfLoaded(true);
    //     setPdfDocument(pdf); // Cache the loaded PDF document

    //     // Extract bookmarks
    //     const outline = await pdf.getOutline();
    //     if (outline) {
    //         const toc = await extractBookmarks(pdf, outline);
    //         setBookmarks(toc);
    //     }

    //     if (pendingPage) {
    //         scrollToPage(pendingPage);
    //         setPendingPage(null);
    //     }
    // };



    // const extractBookmarks = async (pdf, outline, depth = 0) => {
    //     let toc = [];
    //     for (const item of outline) {
    //         const pageNumber = await getPageNumberFromDest(pdf, item.dest);
    //         toc.push({
    //             title: item.title,
    //             page: pageNumber,
    //             depth: depth,
    //         });
    //         if (item.items && item.items.length > 0) {
    //             toc = toc.concat(await extractBookmarks(pdf, item.items, depth + 1));
    //         }
    //     }
    //     return toc;
    // };

    // const getPageNumberFromDest = async (pdf, dest) => {
    //     if (!dest) return null;
    //     const destination = await pdf.getDestination(dest);
    //     const ref = destination[0];
    //     if (ref && ref instanceof Object && ref.num) {
    //         const pageIndex = await pdf.getPageIndex(ref);
    //         return pageIndex + 1;
    //     }
    //     return null;
    // };

    // const goToPage = () => {
    //     if (inputPageNumber > 0 && inputPageNumber <= numPages) {
    //         setPageNumber(inputPageNumber);
    //         scrollToPage(inputPageNumber);
    //     } else {
    //         alert('Invalid page number');
    //     }
    // };

    // const scrollToPage = (pageNumber) => {
    //     if (pageRefs.current[pageNumber - 1]) {
    //         pageRefs.current[pageNumber - 1].scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // };
    

    // const handleBookmarkClick = (page) => {
    //     if (page) {
    //         setPageNumber(page);
    //         setFocusedPage(page); // Set the focused page
    //         scrollToPage(page);
    //     } else {
    //         alert('Section does not have a valid page number');
    //     }
    // };

    // const handleReferenceClick = (reference) => {
    //     const referenceTrim = reference.trim();
    //     const formattedReference = referenceTrim.replace(/_/g, '.');
    //     const referenceMatch = formattedReference.match(/^[A-Z](\.\d+)+/);
    
    //     if (referenceMatch) {
    //         const matched = referenceMatch[0];
    //         const matchedBookmark = bookmarks.find(bookmark => bookmark.title.includes(matched));
    
    //         if (matchedBookmark) {
    //             if (pdfLoaded) {
    //                 setPageNumber(matchedBookmark.page);
    //                 setFocusedPage(matchedBookmark.page); // Set the focused page
    //                 scrollToPage(matchedBookmark.page);
    //                 setShowPdf(true);
    //             } else {
    //                 setPendingPage(matchedBookmark.page);
    //             }
    //         }
    //     }
    // };
    // useEffect(() => {
    //     if (pdfLoaded && pageNumber) {
    //         scrollToPage(pageNumber);
    //         setPageNumber(null);
    //     }
    // }, [pdfLoaded, pageNumber]);

    // const toggleFullScreen = (pageIndex) => {
    //     const page = pageIndex + 1;
    //     setFullScreenPage(fullScreenPage === page ? null : page);
    //     setFocusedPage(page); // Set focusedPage when full screen is toggled
    // };

    // // Controller to go next and prev page
    // const goToNextPage = () => {
    //     if (fullScreenPage < numPages) {
         
    //         setFullScreenPage(fullScreenPage + 1); // Update fullScreenPage to the next page
    //         scrollToPage(fullScreenPage + 1);
    //     }
    // };

    // const goToPrevPage = () => {
    //     if (fullScreenPage > 1) {
           
    //         setFullScreenPage(fullScreenPage - 1); // Update fullScreenPage to the previous page
    //         scrollToPage(fullScreenPage - 1);
    //     }
    // };

    // // Keyboard event listener
    // const handleKeyClick = useCallback((event) => {
    //     if (fullScreenPage) { // Only navigate when a page is in full screen
    //         if (event.key === 'ArrowDown') {
    //             goToNextPage();
    //         } else if (event.key === 'ArrowUp') {
    //             goToPrevPage();
    //         }
    //     }
    // }, [focusedPage, fullScreenPage]);

    // useEffect(() => {
    //     window.addEventListener('keydown', handleKeyClick);
    //     return () => {
    //         window.removeEventListener('keydown', handleKeyClick);
    //     };
    // }, [handleKeyClick]);




  

    // Like And DisLike

    const [messageId, setMessageId] = useState('')
    const [commentValue, setCommentValue] = useState('');
    const [likeDislike, setLikeDislike] = useState('')

    const showPopupClick = (_id, like) => {
        setMessageId(_id);
        setShowPopup(true);
        setLikeDislike(like);
    };

    const hidePopup = () => {
        setShowPopup(false);
    };

    const handleLike = () => {
        fetch(`${chatbotUrl}/message/like/set`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                api_key: apiKey,
                api_secret: apiSecret,
                session_id: sessionId,
                value: likeDislike,
                comment: commentValue,
                message_id: messageId, // Send message_id here
            }),
        })
            .then(response => response.json())
            .then(() => {
                // Update the like state in the messages list
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.message_id === messageId
                            ? { ...msg, like: likeDislike } // Update the like state
                            : msg
                    )
                );
                setShowPopup(false); // Close popup after like action
                setCommentValue("")
            })
            .catch(error => {
                setError(error.message);
                toast.error(`${error}`, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    className: isDarkMode ? "chatbot-toast chatbot-toast-dark" : "chatbot-toast",
                });
            });
    };



      const modelMenuItemStyles = {
        backgroundColor: 'transparent',
        fontSize: '0.875rem',

        MenuListProps: {
            sx: {
                maxWidth: '350px !important', // Set max-width for the MenuList component
                '& ul': {
                    maxWidth: '350px !important', // Set max-width for the ul element
                },
            },
        },

        '&.Mui-selected': {
        backgroundColor: isDarkMode ? '#555' : '#ddd', // Gray for dark mode, light gray for light mode
        },
        '&.Mui-selected:hover': {
        backgroundColor: isDarkMode ? '#666' : '#ccc', // Slightly darker gray on hover when selected
        },
        '&:hover': {
        backgroundColor: isDarkMode ? '#444' : '#eee', // Gray on hover
        },
      };


      // Table Render 
      const markdownComponents = {
        table: ({ node, ...props }) => (
            <div className={`markdown-table-wrapper ${isDarkMode ? 'dark-mode' : ''}`}>
                <table {...props} />
            </div>
        ),
        th: ({ node, ...props }) => <th {...props} className="markdown-table-header" />,
        tr: ({ node, ...props }) => <tr {...props} className="markdown-table-row" />,
        td: ({ node, ...props }) => <td {...props} className="markdown-table-cell" />,
    };


    

    return (
      <div className={`chatbot-container ${isDarkMode ? "dark-mode" : ""}`}>
        <div
          className="chat-overlay"
          style={{ display: isMobile ? overlay : "none" }}
        ></div>
        <div
          className={`chatbot-background ${isDarkMode ? "dark-mode" : ""}`}
        ></div>
        {/* <img className='chatbot-background-image' src={requ
            ire("../../assets/images/Gradient background.png")} /> */}
        <img
          className="chatbot-background-bottom-image"
          src={require("../../assets/images/chatbot/bottom-background.png")}
          loading="lazy"
        />
        <Container
          fluid
          style={{ height: "100%", paddingTop: "15px", display: "flex" }}
        >
          <Row style={{ height: "100%", position: "relative", flex: "1" }}>
            <Col lg={2} className="sidebar-chatbot" style={{ left: left }}>
              <div className={`side-chatbot ${isDarkMode ? "dark-mode" : ""}`}>
                <div className="side-chatbot-container">
                  <div className="chatbot-sidebar-content">
                    <div className="cahabot-profile">
                      <div className="chatbot-profile-img">
                        <img src={miniStar} loading="lazy" />
                      </div>
                      <div>
                        <h1
                          className={`cahabot-profile-name ${
                            isDarkMode ? "dark-mode" : ""
                          }`}
                        >
                          {fullName}
                        </h1>
                        <h1
                          className={`chatbot-profile-title ${
                            isDarkMode ? "dark-mode" : ""
                          }`}
                        >
                          Basic Package
                        </h1>
                      </div>
                      <button
                        onClick={HideSidbarClick}
                        className={`chat-hide-sidebar-btn ${
                          isDarkMode ? "dark-mode" : ""
                        }`}
                      >
                        <svg
                          width="28"
                          height="19"
                          viewBox="0 0 29 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 19.3174V17.171H18.6429V19.3174H0ZM0 8.58552H29V10.7319H0V8.58552ZM22.7857 0V2.14638H0V0H22.7857Z"
                            fill="#000"
                          />
                        </svg>
                      </button>
                    </div>

                    <button className="new-chat" onClick={handleNewChatClick}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1515_1031)">
                          <path
                            d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1515_1031">
                            <rect width="24" height="24" rx="6" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Start a new chat
                    </button>
                    {fullNames.length > 1 && (
                      <FormControl
                        className={`names-filter ${
                          isDarkMode ? "dark-mode" : ""
                        }`}
                      >
                        <Select
                          className={`names-filter-select ${
                            isDarkMode ? "dark-mode" : ""
                          }`}
                          value={selectedName}
                          onChange={handleNameChange}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          MenuProps={CustomMenuProps}
                        >
                          <MenuItem
                            className={`names-filter-item ${
                              isDarkMode ? "dark-mode" : ""
                            }`}
                            value=""
                          >
                            <em>All Users</em>
                          </MenuItem>
                          {fullNames.map((name, index) => (
                            <MenuItem
                              key={index}
                              className={`names-filter-item ${
                                isDarkMode ? "dark-mode" : ""
                              }`}
                              value={name}
                            >
                              <div className="names-filter-item-content">
                                <img src={userItem} alt="User" />
                                <p>{name}</p>
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* Converstaions List */}
                    {chatLoading ? (
                      <div className="chats-loading">
                        <SpinnerLoading />
                      </div>
                    ) : (
                      <div className={`chats ${isDarkMode ? "dark-mode" : ""}`}>
                        {filteredChats.map((item, index) => (
                          <Chat
                            key={index}
                            title={item.conversation_title || "Untitled"}
                            onClick={() => handleDetails(item.name)}
                            onDelete={() => handleDelete(item.name)}
                            onShare={() => handleShareChat(item.name)}
                            isDarkMode={isDarkMode}
                            isActive={activeChat === item.name}
                          />
                        ))}

                        {isFetchingMore && (
                          <div className="loading-more">
                            <SpinnerLoading />
                          </div>
                        )}

                        {!canFetchMore && !isFetchingMore && (
                          <p>No more conversations to load</p>
                        )}
                        <div
                          ref={chatContainerRef}
                          className="load-more-target"
                        />
                      </div>
                    )}
                  </div>

                  <div
                    className={`side-footer-chat ${
                      isDarkMode ? "dark-mode" : ""
                    }`}
                  >
                    {/* <Tool 
                                        title={"Upgrade your package"}
                                        SvgIcon={StarsIcon}
                                    />
                                    <Tool 
                                        title={"Uptades & FAQ"}
                                        SvgIcon={OpenInNewIcon}
                                    /> */}
                    <a href={"/dashboard"} className="logout-chat">
                      <img
                        src={power}
                        className="logout-chat-image"
                        loading="lazy"
                      />
                      <h1 className="logout-chat-title">Exit</h1>
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              lg={10}
              className="chatbot-scroll"
              style={{ height: "86vh" }}
              ref={chatContainerRef}
            >
              <div className="chat-container">
                <div
                  className={`chat-nav-container ${
                    isDarkMode ? "dark-mode" : ""
                  }`}
                >
                  <div className="chat-nav">
                    <div className="d-flex">
                      <button
                        className={`chat-show-sidebar-btn ${
                          isDarkMode ? "dark-mode" : ""
                        }`}
                        onClick={ShowSidbarClick}
                      >
                        <svg
                          width="25"
                          height="16"
                          viewBox="0 0 29 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 19.3174V17.171H18.6429V19.3174H0ZM0 8.58552H29V10.7319H0V8.58552ZM22.7857 0V2.14638H0V0H22.7857Z"
                            fill="#000"
                          />
                        </svg>
                      </button>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          m: 1,
                          ml: 0,
                          transition: "0.3s",
                          padding: "3px 3px",
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          sx={{
                            minWidth: 120,
                            borderRadius: 1,
                            "& .MuiOutlinedInput-notchedOutline": {
                              display: "none",
                            },
                            "& .MuiSelect-root": {
                              color: isDarkMode ? "#f0f0f0" : "#333",
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "#fff",
                              "&:focus": {
                                backgroundColor: isDarkMode
                                  ? "#161616"
                                  : "#f7f7f7",
                              },
                            },
                          }}
                        >
                          <Select
                            id="model-select"
                            value={currentModel}
                            onChange={(event) => {
                              handleModelChange(event); // Handle model change logic
                              handleNewChatClick(); // Clear chat when selection changes
                            }}
                            disableUnderline
                            IconComponent={ExpandMoreIcon}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  maxWidth: "350px !important",
                                  minWidth: "unset !important",
                                  fontFamily: "Poppins400",
                                  borderRadius: 2,
                                  backgroundColor: isDarkMode ? "#333" : "#fff",
                                  color: isDarkMode ? "#f0f0f0" : "#333",
                                  border: isDarkMode
                                    ? "1px solid hsla(0,0%,100%,.1)"
                                    : "1px solid rgba(0,0,0,.1)",
                                },
                              },
                            }}
                            renderValue={(selected) => {
                              // Define how the selected option should appear without the SVG icon
                              switch (selected) {
                                case "polaris":
                                  return (
                                    <div className="selected-model">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="35"
                                        viewBox="0 0 33 38"
                                        fill="none"
                                      >
                                        <path
                                          d="M11.163 26.5999C10.7058 26.5999 10.3146 26.4405 9.98926 26.1219C9.66397 25.8032 9.50104 25.4197 9.50049 24.9713V16.8284C9.50049 16.3806 9.66341 15.9973 9.98926 15.6787C10.3151 15.36 10.7064 15.2004 11.163 15.1999H11.9942V13.5713C11.9942 12.4449 12.3996 11.4848 13.2104 10.6912C14.0211 9.89752 15.0011 9.50042 16.1505 9.49988C17.2998 9.49934 18.2802 9.89644 19.0915 10.6912C19.9028 11.4859 20.3078 12.446 20.3067 13.5713V15.1999H21.138C21.5952 15.1999 21.9867 15.3595 22.3125 15.6787C22.6384 15.9979 22.801 16.3811 22.8005 16.8284V24.9713C22.8005 25.4192 22.6378 25.8027 22.3125 26.1219C21.9872 26.4411 21.5957 26.6004 21.138 26.5999H11.163ZM11.163 24.9713H21.138V16.8284H11.163V24.9713ZM16.1505 22.5284C16.6077 22.5284 16.9992 22.3691 17.325 22.0505C17.6509 21.7318 17.8135 21.3483 17.813 20.8999C17.8124 20.4515 17.6498 20.0682 17.325 19.7501C17.0003 19.432 16.6088 19.2724 16.1505 19.2713C15.6922 19.2702 15.301 19.4298 14.9768 19.7501C14.6526 20.0704 14.4897 20.4536 14.488 20.8999C14.4863 21.3461 14.6493 21.7296 14.9768 22.0505C15.3043 22.3713 15.6955 22.5306 16.1505 22.5284ZM13.6567 15.1999H18.6442V13.5713C18.6442 12.8927 18.4018 12.3159 17.9169 11.8409C17.432 11.3659 16.8432 11.1284 16.1505 11.1284C15.4578 11.1284 14.869 11.3659 14.3841 11.8409C13.8992 12.3159 13.6567 12.8927 13.6567 13.5713V15.1999Z"
                                          fill="#50C878"
                                        />
                                        <path
                                          d="M16.15 37.9979C11.5142 36.7302 7.66356 34.1446 4.59814 30.2411C1.53271 26.3375 0 21.939 0 17.0454V5.55574L16.15 0L32.3 5.55574V17.0454C32.3 21.9376 30.7673 26.3354 27.7019 30.239C24.6364 34.1425 20.7858 36.7274 16.15 37.9979ZM16.15 35.7437C20.149 34.5752 23.456 32.2382 26.0707 28.7326C28.6855 25.2271 29.9929 21.3321 29.9929 17.0475V7.00682L16.15 2.26904L2.30714 7.00682V17.0454C2.30714 21.3299 3.61452 25.225 6.22929 28.7305C8.84405 32.2361 12.151 34.5752 16.15 35.7437Z"
                                          fill="#50C878"
                                        />
                                      </svg>
                                      <div className="selected-model-content">
                                        <h1 className="selected-model-title">
                                          Polaris Server Model
                                        </h1>
                                        <p className="selected-model-para">
                                          This model is fully private and
                                          server-exclusive.
                                        </p>
                                      </div>
                                    </div>
                                  );
                                case "openai":
                                  return (
                                    <h1 className="selected-model-title">
                                      Polaris With Power of ChatGPT
                                    </h1>
                                  );

                                  case "vllm":
                                    return (
                                      <h1 className="selected-model-title">
                                        Polaris With Power of ChatGPT
                                      </h1>
                                    );

                                default:
                                  return "";
                              }
                            }}
                            sx={{
                              color: isDarkMode ? "#f0f0f0" : "#333",
                              border: "none",
                              "& .MuiSvgIcon-root": {
                                color: isDarkMode ? "#f0f0f0" : "#333",
                              },
                              "&:hover": {
                                backgroundColor: isDarkMode
                                  ? "#161616"
                                  : "#f7f7f7",
                                transition: "0.3s",
                              },
                            }}
                          >
                            <MenuItem
                              defaultChecked
                              value="polaris"
                              sx={modelMenuItemStyles}
                            >
                              <div
                                className={`model-list-item ${
                                  isDarkMode ? "dark-mode" : ""
                                }`}
                              >
                                <div className="model-list-item-content">
                                  <div className="model-list-item-icon">
                                    <svg
                                      width="15"
                                      height="15"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="h-4 w-4 text-token-text-primary"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12 7.42a22.323 22.323 0 0 0-2.453 2.127A22.323 22.323 0 0 0 7.42 12a22.32 22.32 0 0 0 2.127 2.453c.807.808 1.636 1.52 2.453 2.128a22.335 22.335 0 0 0 2.453-2.128A22.322 22.322 0 0 0 16.58 12a22.326 22.326 0 0 0-2.127-2.453A22.32 22.32 0 0 0 12 7.42Zm1.751-1.154a24.715 24.715 0 0 1 2.104 1.88 24.722 24.722 0 0 1 1.88 2.103c.316-.55.576-1.085.779-1.59.35-.878.507-1.625.503-2.206-.003-.574-.16-.913-.358-1.111-.199-.199-.537-.356-1.112-.36-.58-.003-1.328.153-2.205.504-.506.203-1.04.464-1.59.78Zm3.983 7.485a24.706 24.706 0 0 1-1.88 2.104 24.727 24.727 0 0 1-2.103 1.88 12.7 12.7 0 0 0 1.59.779c.878.35 1.625.507 2.206.503.574-.003.913-.16 1.111-.358.199-.199.356-.538.36-1.112.003-.58-.154-1.328-.504-2.205a12.688 12.688 0 0 0-.78-1.59ZM12 18.99c.89.57 1.768 1.03 2.605 1.364 1.026.41 2.036.652 2.955.646.925-.006 1.828-.267 2.5-.94.673-.672.934-1.575.94-2.5.006-.919-.236-1.929-.646-2.954A15.688 15.688 0 0 0 18.99 12a15.6 15.6 0 0 0 1.364-2.606c.41-1.025.652-2.035.646-2.954-.006-.925-.267-1.828-.94-2.5-.672-.673-1.575-.934-2.5-.94-.919-.006-1.929.235-2.954.646-.838.335-1.716.795-2.606 1.364a15.69 15.69 0 0 0-2.606-1.364C8.37 3.236 7.36 2.994 6.44 3c-.925.006-1.828.267-2.5.94-.673.672-.934 1.575-.94 2.5-.006.919.235 1.929.646 2.955A15.69 15.69 0 0 0 5.01 12c-.57.89-1.03 1.768-1.364 2.605-.41 1.026-.652 2.036-.646 2.955.006.925.267 1.828.94 2.5.672.673 1.575.934 2.5.94.92.006 1.93-.235 2.955-.646A15.697 15.697 0 0 0 12 18.99Zm-1.751-1.255a24.714 24.714 0 0 1-2.104-1.88 24.713 24.713 0 0 1-1.88-2.104c-.315.55-.576 1.085-.779 1.59-.35.878-.507 1.625-.503 2.206.003.574.16.913.359 1.111.198.199.537.356 1.111.36.58.003 1.328-.153 2.205-.504.506-.203 1.04-.463 1.59-.78Zm-3.983-7.486a24.727 24.727 0 0 1 1.88-2.104 24.724 24.724 0 0 1 2.103-1.88 12.696 12.696 0 0 0-1.59-.779c-.878-.35-1.625-.507-2.206-.503-.574.003-.913.16-1.111.359-.199.198-.356.537-.36 1.111-.003.58.153 1.328.504 2.205.203.506.464 1.04.78 1.59Z"
                                        fill="currentColor"
                                      ></path>
                                    </svg>
                                  </div>
                                  <div className="model-list-item-text">
                                    <div className="model-list-item-title">
                                      Polaris
                                    </div>
                                    <div className="model-list-item-para">
                                      Great for Everyday Tasks
                                    </div>
                                  </div>
                                </div>
                                {currentModel === "polaris" && (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.0755 7.93219C16.5272 8.25003 16.6356 8.87383 16.3178 9.32549L11.5678 16.0755C11.3931 16.3237 11.1152 16.4792 10.8123 16.4981C10.5093 16.517 10.2142 16.3973 10.0101 16.1727L7.51006 13.4227C7.13855 13.014 7.16867 12.3816 7.57733 12.0101C7.98598 11.6386 8.61843 11.6687 8.98994 12.0773L10.6504 13.9039L14.6822 8.17451C15 7.72284 15.6238 7.61436 16.0755 7.93219Z"
                                      fill="currentColor"
                                    ></path>
                                  </svg>
                                )}
                              </div>
                            </MenuItem>

                            <MenuItem value="openai" sx={modelMenuItemStyles}>
                              <div
                                className={`model-list-item ${
                                  isDarkMode ? "dark-mode" : ""
                                }`}
                              >
                                <div className="model-list-item-content">
                                  <div className="model-list-item-icon">
                                    <svg
                                      width="15"
                                      height="15"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="h-4 w-4 text-token-text-primary"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12 7.42a22.323 22.323 0 0 0-2.453 2.127A22.323 22.323 0 0 0 7.42 12a22.32 22.32 0 0 0 2.127 2.453c.807.808 1.636 1.52 2.453 2.128a22.335 22.335 0 0 0 2.453-2.128A22.322 22.322 0 0 0 16.58 12a22.326 22.326 0 0 0-2.127-2.453A22.32 22.32 0 0 0 12 7.42Zm1.751-1.154a24.715 24.715 0 0 1 2.104 1.88 24.722 24.722 0 0 1 1.88 2.103c.316-.55.576-1.085.779-1.59.35-.878.507-1.625.503-2.206-.003-.574-.16-.913-.358-1.111-.199-.199-.537-.356-1.112-.36-.58-.003-1.328.153-2.205.504-.506.203-1.04.464-1.59.78Zm3.983 7.485a24.706 24.706 0 0 1-1.88 2.104 24.727 24.727 0 0 1-2.103 1.88 12.7 12.7 0 0 0 1.59.779c.878.35 1.625.507 2.206.503.574-.003.913-.16 1.111-.358.199-.199.356-.538.36-1.112.003-.58-.154-1.328-.504-2.205a12.688 12.688 0 0 0-.78-1.59ZM12 18.99c.89.57 1.768 1.03 2.605 1.364 1.026.41 2.036.652 2.955.646.925-.006 1.828-.267 2.5-.94.673-.672.934-1.575.94-2.5.006-.919-.236-1.929-.646-2.954A15.688 15.688 0 0 0 18.99 12a15.6 15.6 0 0 0 1.364-2.606c.41-1.025.652-2.035.646-2.954-.006-.925-.267-1.828-.94-2.5-.672-.673-1.575-.934-2.5-.94-.919-.006-1.929.235-2.954.646-.838.335-1.716.795-2.606 1.364a15.69 15.69 0 0 0-2.606-1.364C8.37 3.236 7.36 2.994 6.44 3c-.925.006-1.828.267-2.5.94-.673.672-.934 1.575-.94 2.5-.006.919.235 1.929.646 2.955A15.69 15.69 0 0 0 5.01 12c-.57.89-1.03 1.768-1.364 2.605-.41 1.026-.652 2.036-.646 2.955.006.925.267 1.828.94 2.5.672.673 1.575.934 2.5.94.92.006 1.93-.235 2.955-.646A15.697 15.697 0 0 0 12 18.99Zm-1.751-1.255a24.714 24.714 0 0 1-2.104-1.88 24.713 24.713 0 0 1-1.88-2.104c-.315.55-.576 1.085-.779 1.59-.35.878-.507 1.625-.503 2.206.003.574.16.913.359 1.111.198.199.537.356 1.111.36.58.003 1.328-.153 2.205-.504.506-.203 1.04-.463 1.59-.78Zm-3.983-7.486a24.727 24.727 0 0 1 1.88-2.104 24.724 24.724 0 0 1 2.103-1.88 12.696 12.696 0 0 0-1.59-.779c-.878-.35-1.625-.507-2.206-.503-.574.003-.913.16-1.111.359-.199.198-.356.537-.36 1.111-.003.58.153 1.328.504 2.205.203.506.464 1.04.78 1.59Z"
                                        fill="currentColor"
                                      ></path>
                                    </svg>
                                  </div>
                                  <div className="model-list-item-text">
                                    <div className="model-list-item-title">
                                      Polaris With Power of ChatGPT
                                    </div>
                                    <div className="model-list-item-para">
                                      Great for Everyday Tasks
                                    </div>
                                  </div>
                                </div>
                                {currentModel === "openai" && (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.0755 7.93219C16.5272 8.25003 16.6356 8.87383 16.3178 9.32549L11.5678 16.0755C11.3931 16.3237 11.1152 16.4792 10.8123 16.4981C10.5093 16.517 10.2142 16.3973 10.0101 16.1727L7.51006 13.4227C7.13855 13.014 7.16867 12.3816 7.57733 12.0101C7.98598 11.6386 8.61843 11.6687 8.98994 12.0773L10.6504 13.9039L14.6822 8.17451C15 7.72284 15.6238 7.61436 16.0755 7.93219Z"
                                      fill="currentColor"
                                    ></path>
                                  </svg>
                                )}
                              </div>
                            </MenuItem>

                            <MenuItem value="vllm" sx={modelMenuItemStyles}>
                              <div
                                className={`model-list-item ${
                                  isDarkMode ? "dark-mode" : ""
                                }`}
                              >
                                <div className="model-list-item-content">
                                  <div className="model-list-item-icon">
                                    <svg
                                      width="15"
                                      height="15"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="h-4 w-4 text-token-text-primary"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12 7.42a22.323 22.323 0 0 0-2.453 2.127A22.323 22.323 0 0 0 7.42 12a22.32 22.32 0 0 0 2.127 2.453c.807.808 1.636 1.52 2.453 2.128a22.335 22.335 0 0 0 2.453-2.128A22.322 22.322 0 0 0 16.58 12a22.326 22.326 0 0 0-2.127-2.453A22.32 22.32 0 0 0 12 7.42Zm1.751-1.154a24.715 24.715 0 0 1 2.104 1.88 24.722 24.722 0 0 1 1.88 2.103c.316-.55.576-1.085.779-1.59.35-.878.507-1.625.503-2.206-.003-.574-.16-.913-.358-1.111-.199-.199-.537-.356-1.112-.36-.58-.003-1.328.153-2.205.504-.506.203-1.04.464-1.59.78Zm3.983 7.485a24.706 24.706 0 0 1-1.88 2.104 24.727 24.727 0 0 1-2.103 1.88 12.7 12.7 0 0 0 1.59.779c.878.35 1.625.507 2.206.503.574-.003.913-.16 1.111-.358.199-.199.356-.538.36-1.112.003-.58-.154-1.328-.504-2.205a12.688 12.688 0 0 0-.78-1.59ZM12 18.99c.89.57 1.768 1.03 2.605 1.364 1.026.41 2.036.652 2.955.646.925-.006 1.828-.267 2.5-.94.673-.672.934-1.575.94-2.5.006-.919-.236-1.929-.646-2.954A15.688 15.688 0 0 0 18.99 12a15.6 15.6 0 0 0 1.364-2.606c.41-1.025.652-2.035.646-2.954-.006-.925-.267-1.828-.94-2.5-.672-.673-1.575-.934-2.5-.94-.919-.006-1.929.235-2.954.646-.838.335-1.716.795-2.606 1.364a15.69 15.69 0 0 0-2.606-1.364C8.37 3.236 7.36 2.994 6.44 3c-.925.006-1.828.267-2.5.94-.673.672-.934 1.575-.94 2.5-.006.919.235 1.929.646 2.955A15.69 15.69 0 0 0 5.01 12c-.57.89-1.03 1.768-1.364 2.605-.41 1.026-.652 2.036-.646 2.955.006.925.267 1.828.94 2.5.672.673 1.575.934 2.5.94.92.006 1.93-.235 2.955-.646A15.697 15.697 0 0 0 12 18.99Zm-1.751-1.255a24.714 24.714 0 0 1-2.104-1.88 24.713 24.713 0 0 1-1.88-2.104c-.315.55-.576 1.085-.779 1.59-.35.878-.507 1.625-.503 2.206.003.574.16.913.359 1.111.198.199.537.356 1.111.36.58.003 1.328-.153 2.205-.504.506-.203 1.04-.463 1.59-.78Zm-3.983-7.486a24.727 24.727 0 0 1 1.88-2.104 24.724 24.724 0 0 1 2.103-1.88 12.696 12.696 0 0 0-1.59-.779c-.878-.35-1.625-.507-2.206-.503-.574.003-.913.16-1.111.359-.199.198-.356.537-.36 1.111-.003.58.153 1.328.504 2.205.203.506.464 1.04.78 1.59Z"
                                        fill="currentColor"
                                      ></path>
                                    </svg>
                                  </div>
                                  <div className="model-list-item-text">
                                    <div className="model-list-item-title">
                                      Polaris VLLM
                                    </div>
                                    <div className="model-list-item-para">
                                    Great for Everyday Tasks
                                    </div>
                                  </div>
                                </div>
                                {currentModel === "vllm" && (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM16.0755 7.93219C16.5272 8.25003 16.6356 8.87383 16.3178 9.32549L11.5678 16.0755C11.3931 16.3237 11.1152 16.4792 10.8123 16.4981C10.5093 16.517 10.2142 16.3973 10.0101 16.1727L7.51006 13.4227C7.13855 13.014 7.16867 12.3816 7.57733 12.0101C7.98598 11.6386 8.61843 11.6687 8.98994 12.0773L10.6504 13.9039L14.6822 8.17451C15 7.72284 15.6238 7.61436 16.0755 7.93219Z"
                                      fill="currentColor"
                                    ></path>
                                  </svg>
                                )}
                              </div>
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </div>

                    <div className="chat-theme">
                      <Form>
                        <div
                          className={`theme-switch ${
                            isDarkMode ? "dark-mode" : ""
                          }`}
                        >
                          <svg
                            className="theme-icon"
                            width="17"
                            height="20"
                            viewBox="0 0 17 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              id="Vector"
                              d="M7.59877 4.28842C8.07269 3.05012 8.73363 1.86834 9.60632 0.979688C6.00313 1.14212 2.71183 3.49879 1.34048 7.08199C-0.504496 11.9027 1.90795 17.3066 6.72869 19.1516C10.3119 20.5229 14.2638 19.646 16.7904 17.072C15.5461 17.1284 14.2239 16.831 12.9867 16.3575C8.166 14.5125 5.75379 9.10917 7.59877 4.28842Z"
                              fill="black"
                            />
                          </svg>

                          <Form.Check
                            type="switch"
                            id="theme-switch"
                            checked={!isDarkMode}
                            onChange={toggleTheme}
                          />
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="tabler:sun-filled">
                              <path
                                id="Vector"
                                d="M11.9999 19C12.2448 19 12.4812 19.09 12.6642 19.2527C12.8473 19.4155 12.9642 19.6397 12.9929 19.883L12.9999 20V21C12.9996 21.2549 12.902 21.5 12.727 21.6854C12.5521 21.8707 12.3129 21.9822 12.0585 21.9972C11.804 22.0121 11.5535 21.9293 11.358 21.7657C11.1626 21.6021 11.037 21.3701 11.0069 21.117L10.9999 21V20C10.9999 19.7348 11.1052 19.4804 11.2928 19.2929C11.4803 19.1054 11.7347 19 11.9999 19ZM18.3129 16.91L18.4069 16.993L19.1069 17.693C19.2862 17.873 19.3903 18.1144 19.3981 18.3684C19.4059 18.6223 19.3167 18.8697 19.1486 19.0603C18.9806 19.2508 18.7463 19.3703 18.4934 19.3944C18.2405 19.4185 17.9879 19.3454 17.7869 19.19L17.6929 19.107L16.9929 18.407C16.8203 18.2347 16.7166 18.0054 16.7013 17.762C16.686 17.5187 16.7602 17.2781 16.9098 17.0856C17.0595 16.8931 17.2743 16.7619 17.5139 16.7166C17.7535 16.6714 18.0013 16.7153 18.2109 16.84L18.3129 16.91ZM7.00687 16.993C7.17905 17.1652 7.28248 17.3943 7.29776 17.6373C7.31304 17.8803 7.23912 18.1206 7.08987 18.313L7.00687 18.407L6.30687 19.107C6.12691 19.2863 5.88543 19.3905 5.63148 19.3982C5.37754 19.406 5.13016 19.3168 4.93959 19.1488C4.74902 18.9807 4.62956 18.7464 4.60547 18.4935C4.58138 18.2406 4.65446 17.988 4.80987 17.787L4.89287 17.693L5.59287 16.993C5.7804 16.8055 6.0347 16.7002 6.29987 16.7002C6.56503 16.7002 6.81934 16.8055 7.00687 16.993ZM3.99987 11C4.25475 11.0003 4.4999 11.0979 4.68524 11.2728C4.87057 11.4478 4.9821 11.687 4.99704 11.9414C5.01198 12.1958 4.92919 12.4464 4.7656 12.6418C4.60201 12.8373 4.36996 12.9629 4.11687 12.993L3.99987 13H2.99987C2.74499 12.9997 2.49984 12.9021 2.3145 12.7272C2.12916 12.5522 2.01763 12.313 2.0027 12.0586C1.98776 11.8042 2.07054 11.5536 2.23413 11.3582C2.39772 11.1627 2.62977 11.0371 2.88287 11.007L2.99987 11H3.99987ZM20.9999 11C21.2547 11.0003 21.4999 11.0979 21.6852 11.2728C21.8706 11.4478 21.9821 11.687 21.997 11.9414C22.012 12.1958 21.9292 12.4464 21.7656 12.6418C21.602 12.8373 21.37 12.9629 21.1169 12.993L20.9999 13H19.9999C19.745 12.9997 19.4998 12.9021 19.3145 12.7272C19.1292 12.5522 19.0176 12.313 19.0027 12.0586C18.9878 11.8042 19.0705 11.5536 19.2341 11.3582C19.3977 11.1627 19.6298 11.0371 19.8829 11.007L19.9999 11H20.9999ZM6.21287 4.81L6.30687 4.893L7.00687 5.593C7.18622 5.77296 7.29034 6.01443 7.2981 6.26838C7.30585 6.52233 7.21665 6.76971 7.04862 6.96028C6.88059 7.15084 6.64632 7.27031 6.39339 7.2944C6.14047 7.31849 5.88786 7.24541 5.68687 7.09L5.59287 7.007L4.89287 6.307C4.72096 6.13468 4.6178 5.90557 4.60273 5.66263C4.58767 5.41969 4.66173 5.17959 4.81103 4.98735C4.96033 4.79511 5.17463 4.66393 5.41374 4.61839C5.65285 4.57285 5.90036 4.61609 6.10987 4.74L6.21287 4.81ZM19.1069 4.893C19.279 5.06519 19.3825 5.29429 19.3978 5.53732C19.413 5.78034 19.3391 6.0206 19.1899 6.213L19.1069 6.307L18.4069 7.007C18.2269 7.18635 17.9854 7.29047 17.7315 7.29823C17.4775 7.30598 17.2302 7.21678 17.0396 7.04875C16.849 6.88072 16.7296 6.64645 16.7055 6.39353C16.6814 6.1406 16.7545 5.88799 16.9099 5.687L16.9929 5.593L17.6929 4.893C17.8804 4.70553 18.1347 4.60021 18.3999 4.60021C18.665 4.60021 18.9193 4.70553 19.1069 4.893ZM11.9999 2C12.2448 2.00003 12.4812 2.08996 12.6642 2.25272C12.8473 2.41547 12.9642 2.63975 12.9929 2.883L12.9999 3V4C12.9996 4.25488 12.902 4.50003 12.727 4.68537C12.5521 4.8707 12.3129 4.98223 12.0585 4.99717C11.804 5.01211 11.5535 4.92933 11.358 4.76574C11.1626 4.60214 11.037 4.3701 11.0069 4.117L10.9999 4V3C10.9999 2.73478 11.1052 2.48043 11.2928 2.29289C11.4803 2.10536 11.7347 2 11.9999 2ZM11.9999 7C12.9795 6.99994 13.9377 7.28769 14.7552 7.8275C15.5727 8.36731 16.2137 9.1354 16.5984 10.0364C16.9832 10.9373 17.0948 11.9315 16.9193 12.8953C16.7439 13.8592 16.2892 14.7502 15.6117 15.4579C14.9342 16.1655 14.0637 16.6585 13.1084 16.8756C12.1531 17.0928 11.155 17.0245 10.2382 16.6793C9.32137 16.334 8.52615 15.7271 7.95133 14.9338C7.3765 14.1405 7.04739 13.1958 7.00487 12.217L6.99987 12L7.00487 11.783C7.06079 10.4958 7.61148 9.27978 8.54209 8.38866C9.47271 7.49754 10.7114 7.00007 11.9999 7Z"
                                fill="black"
                              />
                            </g>
                          </svg>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>

                {!currentStream && messages.length === 0 && (
                  <div>
                    <div className="chatbot-desc">
                      <h1 className="chat-title">
                        {translations?.message?.whichLegalTaskCanAiAccelerate
                          ? translations.message.whichLegalTaskCanAiAccelerate
                          : "Which legal task can AI accelerate for you today?"}
                      </h1>
                      <p className="chat-para">
                        {translations?.message?.powerAiAtYourService
                          ? translations.message.powerAiAtYourService
                          : "The power of AI at your service - Tame the knowledge !"}
                      </p>
                    </div>

                    {/* <div className={`chat-btns ${isDarkMode ? 'dark-mode' : ''}`}>
                                            <button className='chat-btn chat-btn-active'>Ask a question</button>
                                            <button className='chat-btn'>Generate a Draft</button>
                                            <button className='chat-btn'>Summarize a case</button>
                                            <button className='chat-btn'>Upload to Summarize </button>
                                        </div> */}

                    <Row
                      className={`chat-features ${
                        isDarkMode ? "dark-mode" : ""
                      } `}
                    >
                      {/* <Feature
                                                title={"Clear and precise"}
                                                para={"Pariatur sint laborum cillum aute consectetur irure."}
                                                SvgIcon={StarIcon}
                                            />
                                            <Feature
                                                title={"Personalized answers"}
                                                para={"Pariatur sint laborum cillum aute consectetur irure."}
                                                SvgIcon={AnswersIcon}
                                            />
                                            <Feature
                                                title={"Increased efficiency"}
                                                para={"Pariatur sint laborum cillum aute consectetur irure."}
                                                SvgIcon={EfficiencyIcon}
                                            /> */}
                    </Row>
                  </div>
                )}
                <div className="chat-messages">
                  {messages.map((message, index) => (
                    <div
                      key={index}
                      className={`chat-response ${
                        message.isUser ? "user-message" : "bot-message"
                      } ${isDarkMode ? "dark-mode" : ""}`}
                    >
                      <img
                        src={message.isUser ? userImg : botImg}
                        alt={message.isUser ? "User" : "Bot"}
                        loading="lazy"
                      />
                      <p
                        className={`chat-response-para ${
                          isArabicText(message.text) ? "arabic-text" : ""
                        }`}
                        dir={getDirection(message.text)}
                      >
                        {message.isUser ? (
                          message.text
                        ) : (
                          <ReactMarkdown
                            components={markdownComponents}
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeRaw]}
                          >
                            {message.text}
                          </ReactMarkdown>
                        )}
                        {!message.isUser && (
                          <>
                            <div className="chat-response-refrences">
                              {message?.references?.length > 0 ? (
                                message.references.map(
                                  (reference, refIndex) => {
                                    if (
                                      typeof reference === "object" &&
                                      reference.label &&
                                      reference.link
                                    ) {
                                      return (
                                        <a
                                          href={reference.link}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          key={refIndex}
                                          className="chat-reference-link"
                                        >
                                          <Tooltip
                                            title={reference.label}
                                            id={`tooltip-${refIndex}`}
                                            arrow
                                            placement="top"
                                            effect="solid"
                                          >
                                            <div className="chat-reference-item">
                                              {reference.label.length > 40
                                                ? `${reference.label.substring(
                                                    0,
                                                    40
                                                  )}...`
                                                : reference.label}
                                              <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g id="fluent:open-24-filled">
                                                  <path
                                                    id="Vector"
                                                    d="M3.90625 3.125C3.475 3.125 3.125 3.475 3.125 3.90625V11.0938C3.125 11.525 3.475 11.875 3.90625 11.875H11.0938C11.525 11.875 11.875 11.525 11.875 11.0938V8.75C11.875 8.58424 11.9408 8.42527 12.0581 8.30806C12.1753 8.19085 12.3342 8.125 12.5 8.125C12.6658 8.125 12.8247 8.19085 12.9419 8.30806C13.0592 8.42527 13.125 8.58424 13.125 8.75V11.0938C13.125 11.6325 12.911 12.1491 12.5301 12.5301C12.1491 12.911 11.6325 13.125 11.0938 13.125H3.90625C3.36753 13.125 2.85087 12.911 2.46994 12.5301C2.08901 12.1491 1.875 11.6325 1.875 11.0938V3.90625C1.875 3.36753 2.08901 2.85087 2.46994 2.46994C2.85087 2.08901 3.36753 1.875 3.90625 1.875H6.25C6.41576 1.875 6.57473 1.94085 6.69194 2.05806C6.80915 2.17527 6.875 2.33424 6.875 2.5C6.875 2.66576 6.80915 2.82473 6.69194 2.94194C6.57473 3.05915 6.41576 3.125 6.25 3.125H3.90625ZM8.75 3.125C8.58424 3.125 8.42527 3.05915 8.30806 2.94194C8.19085 2.82473 8.125 2.66576 8.125 2.5C8.125 2.33424 8.19085 2.17527 8.30806 2.05806C8.42527 1.94085 8.58424 1.875 8.75 1.875H12.5C12.6658 1.875 12.8247 1.94085 12.9419 2.05806C13.0592 2.17527 13.125 2.33424 13.125 2.5V6.25C13.125 6.41576 13.0592 6.57473 12.9419 6.69194C12.8247 6.80915 12.6658 6.875 12.5 6.875C12.3342 6.875 12.1753 6.80915 12.0581 6.69194C11.9408 6.57473 11.875 6.41576 11.875 6.25V4.00875L9.19187 6.69187C9.074 6.80572 8.91612 6.86872 8.75225 6.8673C8.58838 6.86587 8.43162 6.80014 8.31574 6.68426C8.19986 6.56838 8.13413 6.41162 8.1327 6.24775C8.13128 6.08388 8.19428 5.926 8.30813 5.80813L10.9913 3.125H8.75Z"
                                                    fill={"#2DB0D8"}
                                                  />
                                                </g>
                                              </svg>
                                            </div>
                                          </Tooltip>
                                        </a>
                                      );
                                    } else {
                                      console.error(
                                        "Invalid reference object:",
                                        reference
                                      );
                                      return null;
                                    }
                                  }
                                )
                              ) : (
                                <div className="d-none"></div>
                              )}
                            </div>

                            <div className="chat-response-icons">
                              <button
                                className="chat-response-icon"
                                onClick={() => copyToClipboard(message.text)}
                              >
                                <img src={copyIcon} loading="lazy" />
                              </button>
                              <svg
                                className="like-icon"
                                onClick={() =>
                                  showPopupClick(message.message_id, 1)
                                }
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.49998 7.29996L7.29996 1C7.85691 1 8.39105 1.22125 8.78487 1.61507C9.1787 2.0089 9.39995 2.54304 9.39995 3.09999V5.89997H13.3619C13.5649 5.89767 13.7659 5.93952 13.951 6.02262C14.1362 6.10572 14.301 6.22808 14.4342 6.38123C14.5674 6.53437 14.6657 6.71464 14.7223 6.90954C14.7788 7.10444 14.7924 7.30931 14.7619 7.50996L13.7959 13.8099C13.7453 14.1437 13.5757 14.448 13.3185 14.6667C13.0612 14.8854 12.7336 15.0037 12.3959 14.9999H4.49998M4.49998 7.29996V14.9999M4.49998 7.29996H2.39999C2.02869 7.29996 1.6726 7.44746 1.41005 7.71001C1.1475 7.97256 1 8.32865 1 8.69995V13.5999C1 13.9712 1.1475 14.3273 1.41005 14.5899C1.6726 14.8524 2.02869 14.9999 2.39999 14.9999H4.49998"
                                  stroke={`${
                                    message.like === 1 ? "#2DB0D8" : "#C5C5D1"
                                  }`}
                                  stroke-width="1.39999"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>

                              <svg
                                className="like-icon"
                                onClick={() =>
                                  showPopupClick(message.message_id, 0)
                                }
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.2777 8.70011L8.47772 15C7.92077 15 7.38664 14.7788 6.99282 14.3849C6.599 13.9911 6.37776 13.457 6.37776 12.9V10.1001H2.41583C2.2129 10.1024 2.01189 10.0605 1.82674 9.97744C1.64159 9.89434 1.47671 9.77198 1.34355 9.61884C1.21038 9.46569 1.1121 9.28543 1.05551 9.09053C0.998931 8.89563 0.985398 8.69076 1.01585 8.49012L1.98184 2.19023C2.03246 1.8564 2.20203 1.55212 2.45929 1.33344C2.71656 1.11477 3.04419 0.996436 3.38181 1.00025H11.2777M11.2777 8.70011V1.00025M11.2777 8.70011H13.1466C13.5428 8.70712 13.9277 8.56842 14.2284 8.31035C14.5291 8.05227 14.7245 7.69279 14.7776 7.30014V2.40023C14.7245 2.00758 14.5291 1.64809 14.2284 1.39002C13.9277 1.13195 13.5428 0.993247 13.1466 1.00025H11.2777"
                                  stroke={`${
                                    message.like === 0 ? "#2DB0D8" : "#C5C5D1"
                                  }`}
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                          </>
                        )}
                      </p>
                    </div>
                  ))}

                  {currentStream && (
                    <div
                      className={`chat-response bot-message ${
                        isDarkMode ? "dark-mode" : ""
                      }`}
                    >
                      <img src={botImg} alt="Bot" loading="lazy" />
                      <div
                        className={`chat-response-para ${
                          isArabicText(message.text) ? "arabic-text" : ""
                        }`}
                        dir={getDirection(currentStream)}
                      >
                        <ReactMarkdown
                          components={markdownComponents}
                          key={currentStream.length}
                          remarkPlugins={[remarkGfm]}
                          rehypePlugins={[rehypeRaw]}
                        >
                          {currentStream}
                        </ReactMarkdown>
                      </div>
                    </div>
                  )}
                  {loading && !currentStream && (
                    <div
                      className={`loading-indicator ${
                        isDarkMode ? "dark-mode" : ""
                      }`}
                    >
                      <Skeleton height={12} width={"100%"} />
                      <Skeleton height={12} width={"75%"} />
                    </div>
                  )}
                  <div
                    style={{ clear: "both", visibility: "hidden", height: 1 }}
                    ref={messagesEndRef}
                  />
                </div>

                {/* {
                                chatResponse && ((

                                    <div className={`chat-response ${isDarkMode ? 'dark-mode' : ''}`}>
                                        <p className='chat-response-para'>{chatResponse}</p>
                                    </div>
                                ))
                            } */}

                {/* {
                                (!firstResizable || !showPdf) && ( */}
                <div className="chat-input-send-container">
                  <div
                    className={`chat-input-container ${
                      isDarkMode ? "dark-mode" : ""
                    }`}
                  >
                    <textarea
                      ref={textareaRef} // Attach the ref to the textarea
                      className={`chat-input ${isDarkMode ? "dark-mode" : ""} ${
                        isArabicText(chatInput) ? "arabic-text" : ""
                      }`}
                      placeholder={
                        "Example : “What are the key requirements of the Canada Labour Code?”"
                      }
                      value={chatInput}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      dir={getDirection(chatInput)}
                      style={{
                        overflow: textareaHeight >= 150 ? "auto" : "hidden",
                        height: `${textareaHeight}px`,
                      }}
                    />

                    <div className="chat-input-btn-container">
                      <div
                        className="chat-input-filter"
                        onClick={handleOpenJurisdiction}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="18"
                          viewBox="0 0 14 17"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.03226 0.792271C9.03226 0.739231 9.00847 0.688364 8.96612 0.65086C8.92377 0.613355 8.86634 0.592285 8.80645 0.592285H2.48387C1.82511 0.592285 1.19332 0.824054 0.727509 1.2366C0.261693 1.64915 0 2.20869 0 2.79213V13.9913C0 14.5748 0.261693 15.1343 0.727509 15.5468C1.19332 15.9594 1.82511 16.1912 2.48387 16.1912H11.5161C12.1749 16.1912 12.8067 15.9594 13.2725 15.5468C13.7383 15.1343 14 14.5748 14 13.9913V6.10949C14 6.05645 13.9762 6.00558 13.9339 5.96808C13.8915 5.93057 13.8341 5.9095 13.7742 5.9095H9.70968C9.53001 5.9095 9.35771 5.84629 9.23067 5.73378C9.10363 5.62127 9.03226 5.46866 9.03226 5.30955V0.792271ZM9.70968 8.59171C9.88934 8.59171 10.0616 8.65492 10.1887 8.76743C10.3157 8.87995 10.3871 9.03255 10.3871 9.19167C10.3871 9.35078 10.3157 9.50339 10.1887 9.6159C10.0616 9.72841 9.88934 9.79162 9.70968 9.79162H4.29032C4.11066 9.79162 3.93836 9.72841 3.81132 9.6159C3.68427 9.50339 3.6129 9.35078 3.6129 9.19167C3.6129 9.03255 3.68427 8.87995 3.81132 8.76743C3.93836 8.65492 4.11066 8.59171 4.29032 8.59171H9.70968ZM9.70968 11.7915C9.88934 11.7915 10.0616 11.8547 10.1887 11.9672C10.3157 12.0797 10.3871 12.2323 10.3871 12.3914C10.3871 12.5506 10.3157 12.7032 10.1887 12.8157C10.0616 12.9282 9.88934 12.9914 9.70968 12.9914H4.29032C4.11066 12.9914 3.93836 12.9282 3.81132 12.8157C3.68427 12.7032 3.6129 12.5506 3.6129 12.3914C3.6129 12.2323 3.68427 12.0797 3.81132 11.9672C3.93836 11.8547 4.11066 11.7915 4.29032 11.7915H9.70968Z"
                            fill="white"
                          />
                          <path
                            d="M10.5 0.817929C10.5 0.638716 10.6827 0.524761 10.818 0.636768C10.9329 0.732219 11.0348 0.843253 11.1237 0.96987L13.9754 5.05767C14.0398 5.15118 13.9697 5.27195 13.8581 5.27195H10.7366C10.6739 5.27195 10.6137 5.24629 10.5693 5.20063C10.5249 5.15497 10.5 5.09303 10.5 5.02845V0.817929Z"
                            fill="white"
                          />
                        </svg>
                        <h1 className="chat-input-filter-title">Filter Docs</h1>
                      </div>
                      <button
                        className={`chat-input-btn ${
                          isDarkMode ? "dark-mode" : ""
                        }`}
                        onClick={handleSendClick}
                        disabled={loading || isSending}
                      >
                        <img src={send} loading="lazy" />
                      </button>
                    </div>
                  </div>
                </div>
                {/* ) */}

                {/* } */}
              </div>
            </Col>

            {/* {
                        firstResizable && showPdf && (
                            <div className='chat-input-send-container'>
                                <div className='chat-input-container'>
                                    <input
                                        type='text'
                                        className={`chat-input ${isDarkMode ? 'dark-mode' : ''}`}
                                        placeholder='Example : “what are dubai code regulations?”'
                                        value={chatInput}
                                        onKeyDown={handleKeyDown}
                                        onChange={e => setChatInput(e.target.value)}
                                    />
                                    <button className={`chat-input-btn ${isDarkMode ? 'dark-mode' : ''}`} onClick={handleSendClick} disabled={loading || isSending}>
                                        <img src={send} loading="lazy" />
                                    </button>
                                </div>
                            </div>
                        )
                    } */}
          </Row>

          {/* <ResizableBox
                    width={300}
                    height={window.innerHeight}
                    minConstraints={[300, window.innerHeight]}
                    maxConstraints={[window.innerWidth * 0.5, window.innerHeight]}
                    resizeHandles={['w']}
                    axis="x"
                    style={{ overflow: 'hidden' }}
                    className={`${showPdf ? 'd-block' : 'd-none'}`}
                >
                    <div style={{ width: '100%', height: '100vh' }}>
                        <button className="viewer-close" onClick={() => setShowPdf(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
                                <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
                            </svg>
                        </button>
                        <Document
                            file={pdfFile}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={(error) => console.error('Failed to load PDF file.', error)}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <div
                                    key={`page_${index + 1}`}
                                    ref={(el) => (pageRefs.current[index] = el)}
                                    className={`pdf-page ${
                                        focusedPage === index + 1 ? 'blur' : ''
                                    } ${fullScreenPage === index + 1 ? 'full-screen' : ''}`} // Full screen if it matches the fullScreenPage
                                    onClick={() => toggleFullScreen(index)}
                                    style={{ marginBottom: '20px' }}
                                >
                                    <Page pageNumber={index + 1} renderTextLayer={false} />
                                </div>
                            ))}
                        </Document>

                        {/* Navigation Buttons */}
          {/* {fullScreenPage && (
                            <div className="navigation-buttons">
                                <button onClick={goToPrevPage} disabled={focusedPage <= 1}>Previous</button>
                                <button onClick={goToNextPage} disabled={focusedPage >= numPages}>Next</button>
                            </div>
                        )}
                    </div>
                </ResizableBox>  */}
        </Container>

        <Modal
          isOpen={showPopup}
          onRequestClose={hidePopup}
          overlayClassName={`${isDarkMode ? "custom-modal-overlay" : ""}`}
          className={`${isDarkMode ? "dark-mode" : ""}`}
        >
          <div
            className={`confirm-delete-container ${
              isDarkMode ? "dark-mode" : ""
            }`}
          >
            <div className="confirm-delete-content">
              <TextArea
                autoSize={false}
                className="comment-text"
                value={commentValue} // Bind the state to TextArea
                onChange={(e) => setCommentValue(e.target.value)} // Update state on change
              />
            </div>
            <div className="confirm-btns">
              <button className="comment-btn" onClick={handleLike}>
                Add Comment
              </button>
              <button className="cancle-delete" onClick={handleLike}>
                Cancel
              </button>
            </div>
          </div>
        </Modal>

        {/* Jurisdiction Modal */}
        <JusModal
          open={jurisdiction}
          onClose={handleCloseJurisdiction}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="jurisdiction-modal-container"
        >
          <Jurisdiction />
        </JusModal> 
        <Modal
          isOpen={showWarn}
          onRequestClose={closeWarn}
          contentLabel="Warning Popup"
        >
          <div className='warn-container'>
            <div className='warn-content'>
              <h1 className='warn-title'>
                {translations?.message?.warning
                  ? translations.message.warning
                  : "Warning"}
              </h1>
              <p className='warn-para'>
                {translations?.message?.warningOpenAi
                  ? translations.message.warningOpenAi
                  : "Your data is being sent to third party and may not be secure."}
              </p>
            </div>
            <div className='warn-btns'>
              <button className='warn-btn' onClick={closeWarn}>
              {translations?.message?.ok
                  ? translations.message.ok
                  : "Ok"}
              </button>
            </div>
          </div>
        </Modal>


      </div>
    );
}

export default ChatBot;
